import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useSetEntityMeta = () => {
  const setEntityMeta = useEntityDetailsDataStore(
    (state) => state.setEntityMeta,
  );
  return setEntityMeta;
};
